<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <v-row class="mt-0 mb-2" justify="space-between" no-gutters>
        <v-col cols="12" md="4">
          <v-card class="py-3 px-4 vcard_area">
            <v-row>
              <v-col cols="12" md="7">
                <div class="text-h1 mb-2">Categorias</div>
                <div class="text text--thin mb-2">As categorias incluídas aqui são exibidas no cadastro de produtos</div>
                <v-btn v-if="$root.Permissions.admin()" @click="dialogNovo = true" color="primary" class="mt-1"><v-icon class="mr-1">category</v-icon>Nova categoria</v-btn>
              </v-col>
              <v-col cols="12" md="5" v-if="$root.Permissions.admin()">
                <div class="icon_area" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                  <v-icon>add</v-icon>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="dados"
        :search="search"
        multi-sort
        class="elevation-1 base_table"
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
        <template v-slot:top>
          <v-row no-gutters align="center" justify="space-between">
            <v-row no-gutters>
              <div class="py-2 px-2">
                <v-text-field
                  clearable
                  hide-details=""
                  clear-icon="close"
                  v-model="search"
                  outlined
                  label="Busca"
                ></v-text-field>
              </div>
            </v-row>
            <div>
              <v-menu
                bottom
                center
                offset-y
                max-height="400"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    Exportar
                    <v-icon>arrow_drop_down</v-icon>
                  </div>
                </template>
                <v-list>
                  <v-list-item @click="exportXls()">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">receipt_long</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para XLS</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </v-row>
        </template>
        <template v-slot:item.cat_icone="{ item }">
            <v-icon :dark="$vuetify.theme.dark"> {{ verifyNameIcon(item.cat_icone) }} </v-icon>
        </template>
        <template v-slot:item.cat_cor="{ item }">
            <div class="categoria_cor" :style="'background-color:'+item.cat_cor" />
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openNovo(item)" color="primary" class="mr-2">
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top v-if="item.cat_id > 7">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openDialogDelete(item)" color="primary" class="ml-2">
                  delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <v-dialog
      v-model="dialogNovo"
      persistent
      max-width="500px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{categoria.uuid_cat_id ? 'Editar categoria' : 'Nova categoria'}}
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formCategorias">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
              <v-text-field
                v-model="categoria.cat_nome"
                label="Nome*"
                :rules="[rules.required]"
                autofocus
                outlined
                :readonly="categoria.cat_id <= 7"
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
              <v-text-field
                v-model="categoria.cat_cor"
                label="Cor*"
                readonly
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
                class="ma-0 pa-0"
                solo
              >
                <template v-slot:append>
                  <v-menu v-model="menu" top nudge-bottom="105" nudge-left="16" :close-on-content-click="false">
                    <template v-slot:activator="{ on }">
                      <div class="categoria_cor" :style="'background-color:'+categoria.cat_cor" v-on="on" />
                    </template>
                    <v-card>
                      <v-card-text class="pa-0">
                        <v-color-picker
                          v-model="categoria.cat_cor"
                          dot-size="13"
                          hide-inputs
                          hide-mode-switch
                        />
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
              <v-dialog
                v-model="dialogIcons"
                :close-on-content-click="false"
                :nudge-right="40"
                persistent
                transition="scale-transition"
                offset-y
                max-width="700px"
                max-height="850px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="categoria.cat_icone"
                    :append-outer-icon="selectedIcon"
                    label="Ícone"
                    v-bind="attrs"
                    v-on="on"
                    @click="pullIcons()"
                    :rules="[rules.required]"
                    outlined
                    :disabled="salvando"
                    :loading="salvando"
                    readonly
                  >
                  </v-text-field>
                </template>
                <v-card>
                  <v-app-bar
                    scroll-target="#scrolling-techniques-7"
                    elevation="0"
                  >
                    <v-row align="center" justify="space-between">
                      <v-col cols="10">
                      </v-col>
                      <v-col cols="2" class="text-right">
                        <v-icon @click="closeIcons()">close</v-icon>
                      </v-col>
                    </v-row>
                  </v-app-bar>
                  <v-sheet
                    id="scrolling-techniques-7"
                    class="overflow-y-auto"
                    max-height="600"
                  >
                    <v-col cols="12">
                      <div v-if="loadingIcons">
                        <v-skeleton-loader type="table"></v-skeleton-loader>
                      </div>
                      <v-btn
                        v-for="(item, i) in allIcons"
                        :key="i"
                        @click="saveIcon(item)"
                        class="mr-2 mb-2"
                        min-height="30"
                      >
                          <v-icon :dark="$vuetify.theme.dark"> {{i > 6 ? 'mdi-'+item : item}} </v-icon>
                      </v-btn>
                    </v-col>
                  </v-sheet>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
         </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditCategorias()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Categoria
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelCategoriaDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir categoria <b class="text-primary">{{categoria ? categoria.cat_nome : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="cancelCategoriaDelete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :disabled="salvando"
            :loading="salvando"
            @click="removeCategoria()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
import { icons } from '@/plugins/icons.js'
export default {
  data () {
    return {
      loading: true,
      loadingIcons: false,
      salvando: false,
      dialogNovo: false,
      dialogExcluir: false,
      search: '',
      dialogIcons: false,
      selectedIcon: 'mdi-apps',
      searchIcon: '',
      allIcons: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'cat_id',
          width: 150
        },
        { text: 'Nome', value: 'cat_nome' },
        { text: 'Ícone', value: 'cat_icone' },
        { text: 'Cor', value: 'cat_cor' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dados: [],
      menu: false,
      rules: {
        required: value => !!value || 'Obrigatório.',
        min: v => v.length >= 6 || 'Mínimo 6 caracteres',
        size: value => !value || value.size < 10000000 || 'Imagem precisa ter menos que 10MB!'
      },
      categoria: {
        cat_nome: '',
        cat_icone: '',
        cat_cor: '#1976D2',
        uuid_int_id: '',
        uuid_dis_id: ''
      }
    }
  },
  methods: {
    swatchStyle (cor) {
      const { menu } = this
      return {
        backgroundColor: cor,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        borderRadius: menu ? '50%' : '4px',
        transition: 'border-radius 200ms ease-in-out'
      }
    },
    pullIcons () {
      this.loadingIcons = true
      setTimeout(() => {
        this.allIcons = icons
        this.loadingIcons = false
      }, 100)
    },
    closeIcons () {
      this.allIcons = []
      this.loadingIcons = true
      setTimeout(() => {
        this.dialogIcons = false
        this.loadingIcons = false
      }, 100)
    },
    saveIcon: function (icon) {
      let filterIcons = ['solar_power', 'heat_pump', 'cable', 'widgets', 'foundation', 'electric_meter', 'inventory_2']
      this.categoria.cat_icone = icon
      let passou = false
      filterIcons.filter((i) => {
        if (i === icon) {
          this.selectedIcon = icon
          passou = true
        }
        if (i !== icon && !passou) {
          this.selectedIcon = 'mdi-' + icon
        }
      })
      this.allIcons = []
      this.dialogIcons = false
    },
    async exportXls () {
      this.loadingXls = true
      Api.post('relatorios/exportar', {
        headers: this.someHeader(),
        busca: this.search,
        type: 'produtos-categorias'
      })
        .then(res => {
          this.downloadXls(res.data.url)
          this.removeXls(res.data.url)
          this.loadingXls = false
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao fazer o download!',
            color: 'error'
          })
        })
    },
    async downloadXls (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    removeXls (url) {
      let data = {
        url: url
      }
      Api.post('relatorios/remove-s3', data)
    },
    someHeader () {
      let cabecalhos = []
      this.headers.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações' && header.text !== 'Usuários' && header.text !== 'Imagem') cabecalhos.push(header)
      })
      return cabecalhos
    },
    loadFunctions () {
      this.getCategorias()
    },
    isObject (val) {
      if (val) {
        return val instanceof Object
      } else {
        return true
      }
    },
    async getCategorias () {
      this.loading = true
      await Api.get('produtos/categorias')
        .then(res => {
          if (res.data) {
            let info = []
            if (res.data.length > 0) {
              res.data.map(item => {
                info.push({
                  uuid_cat_id: item.uuid_cat_id,
                  cat_id: item.cat_id,
                  cat_nome: item.cat_nome,
                  cat_cor: item.cat_cor,
                  cat_icone: item.cat_icone
                })
              })
            }
            this.dados = info
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as categorias!',
            color: 'error'
          })
          console.log(err)
        })
    },
    saveEditCategorias () {
      if (!this.$refs.formCategorias.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'produtos/categorias/nova'
      let editado = false
      if (this.categoria.uuid_cat_id) {
        endpoint = 'produtos/categorias/edita'
        editado = true
      }
      Api.post(endpoint, this.categoria)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Categoria atualizada com sucesso!' : 'Categoria cadastrada com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.getCategorias()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    removeCategoria () {
      this.salvando = true
      Api.delete(`produtos/categorias/remove/${this.categoria.uuid_cat_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.msg
          })
          this.dialogExcluir = false
          this.salvando = false
          this.closeDialog()
          this.getCategorias()
          this.$root.SnackControl.open(this, {
            text: 'Categoria removida com sucesso!',
            color: 'success'
          })
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover categoria!',
            color: 'error'
          })
        })
    },
    openNovo (item) {
      this.categoria = JSON.parse(JSON.stringify(item))
      this.selectedIcon = this.categoria.cat_id <= 7 ? this.categoria.cat_icone : 'mdi-' + this.categoria.cat_icone
      this.dialogNovo = true
    },
    openDialogDelete (item) {
      this.categoria = JSON.parse(JSON.stringify(item))
      this.dialogExcluir = true
    },
    cancelCategoriaDelete () {
      this.closeDialog()
      this.dialogExcluir = false
    },
    closeDialog () {
      this.categoria = {
        cat_nome: '',
        cat_cor: '#1976D2',
        cat_icone: '',
        uuid_int_id: '',
        uuid_dis_id: ''
      }
      this.selectedIcon = 'mdi-apps'
      if (this.$refs.formCategorias) {
        this.$refs.formCategorias.resetValidation()
      }
      this.dialogNovo = false
    },
    verifyPermissions () {
      if (this.$root.Permissions.admin()) return true
      this.headers.pop()
    },
    verifyNameIcon (icon) {
      let filterIcons = ['solar_power', 'heat_pump', 'cable', 'widgets', 'foundation', 'electric_meter', 'inventory_2']
      let passou = false
      let icone = ''
      filterIcons.filter((i) => {
        if (i === icon) {
          icone = icon
          passou = true
        }
        if (i !== icon && !passou) {
          icone = 'mdi-' + icon
        }
      })
      return icone
    }
  },
  created () {
    this.verifyPermissions()
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
>>> .v-input__append-inner {
  margin-top: 0 !important;
}
.logotipo {
  max-height: 250px;
  max-width: 250px;
}
.v-file-input {
  >>>.v-input__prepend-outer {
    margin-top: 10px!important;
  }
}
.categoria_logo {
  max-height: 100px;
  margin: 5px 0;
  max-width: 200px;
}

.categoria_cor {
  cursor: pointer;
  height: 30px;
  width: 30px;
  border-radius: 4px;
  transition: 'border-radius 200ms ease-in-out';
}
</style>



// WEBPACK FOOTER //
// src/pages/configuracoes/Categorias.vue